// Homepage FAQ entries, in display order, keyed into the `HomePage.faq.items` message namespace.
// The visible accordion (src/components/home/FAQ.tsx) and the FAQPage structured data
// (src/config/structured-data.ts) both iterate this list, so the markup cannot drift from the text
// on the page — which is what Google requires of a FAQPage rich result.
export const HOME_FAQ_IDS = [
    'services',
    'countries',
    'vehicles-exported',
    'warehouse-locations',
    'auction-purchase',
] as const;
